function loading(){
	var i = 0,
	overlay = document.querySelector('.full-overlay');
	overlay.style.display = "flex";
	setTimeout(function(){overlay.style.opacity = "1"}, 100);

	function move() {
	  if (i == 0) {
	    i = 1;
	    var elem = document.getElementById("loading-bar");
	    var width = 1;
	    var id = setInterval(frame, 50);
	    function frame() {
	      if (width >= 99) {
	        clearInterval(id);
	        i = 0;
	      } else {
	        width > 95 ? width = 99 : width = width + 4;
	        elem.style.width = width + "%";
	        document.getElementById("load__num").innerText = width;
	      }
	    }
	  }
	}
	move();
}

function checkIfLoaded(){
	var load = setInterval(check, 300),
		elem = document.getElementById("loading-bar"),
		overlay = document.querySelector(".full-overlay");

	function check(){
		if (elem.style.width == "99%") {
			overlay.style.opacity = 0;
		    setTimeout(function(){overlay.style.display = "none"}, 600);
		    clearInterval(load);
		}
	}
}

export { loading, checkIfLoaded }
